
import VideoOne from '../Videos/video-one.vue'
export default {
  components: {
    VideoOne,
  },
  data() {
    return {
      activeIndex: 0,
    }
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    item() {
      if (this.items.length - 1 < this.activeIndex || this.activeIndex < 0)
        return this.items[this.items.length - 1]
      return this.items[this.activeIndex]
    },
  },
  methods: {
    moveLeft() {
      this.clearTimeout()
      if (this.activeIndex - 1 < 0) {
        this.activeIndex = this.items.length - 1
      } else this.activeIndex -= 1
      this.start()
    },
    moveRight() {
      this.clearTimeout()
      if (this.activeIndex + 1 > this.items.length - 1) {
        this.activeIndex = 0
      } else {
        this.activeIndex += 1
      }
      this.start()
    },
    clearTimeout() {
      if (this.autoPlayTimeout > -1) clearTimeout(this.autoPlayTimeout)
    },
    start() {
      this.autoPlayTimeout = setTimeout(() => {
        this.moveRight()
      }, this.item.interval)
    },
  },
  mounted() {
    this.start()
  },
}
